import { apiFetch, source } from 'src/modules/common/api';
import { getBearer } from 'src/utils/api';

export const getDailyBoost = () => apiFetch(`${source}/users/me/daily-boost`, {
  headers: { ...getBearer() },
});

export const postDailyBoostRepair = () => apiFetch(`${source}/users/me/daily-boost/freeze`, {
  method: 'POST',
  headers: { ...getBearer() },
});

// Card-paid restore (CardPay): body carries streakId, paymentMethodId 4,
// timezone and card{number,cvv,expiration{month,year},save}. A 200 with
// redirectUrl means 3D Secure — navigate there; the webhook settles it.
export const postDailyBoostRestoreInit = (body) => apiFetch(`${source}/users/me/daily-boost/restore/init`, {
  method: 'POST',
  headers: {
    ...getBearer(),
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(body),
});
